module.exports = __webpack_public_path__ + "static/media/ole32_8.7616cda5.ico";